"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MediaProfile;

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _urlSearchParams = _interopRequireDefault(require("@ungap/url-search-params"));

var _WorkflowStateFilter = _interopRequireDefault(require("../../containers/WorkflowStateFilter"));

var _WorkflowAudienceProfiling = _interopRequireDefault(require("../../containers/WorkflowAudienceProfiling"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function MediaProfile(props) {
  var searchParams = new _urlSearchParams["default"](props.location.search);
  var useQuadrantPersonas = searchParams.get('useQuadrantPersonas') || false;
  var personas = (0, _reactRedux.useSelector)(function (state) {
    return state.messageStreams.personas;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "media-profile"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text--center media-profile__title"
  }, "Media Profile"), /*#__PURE__*/React.createElement(_WorkflowStateFilter["default"], {
    location: props.location,
    displayStateFilter: true
  }), /*#__PURE__*/React.createElement(_WorkflowAudienceProfiling["default"], {
    quadrantPersonas: useQuadrantPersonas ? personas : null,
    minShareOfAudience: 10,
    themesFor: "media",
    tableTitle: "Audience Profile"
  }));
}